routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('photos', {
      url: '/manage/photos',
      template: require('./index.html'),
      controller: 'PhotoManagerController',
      controllerAs: 'photoManager',
      authRequired: true
    });
}



// WEBPACK FOOTER //
// ./src/app/features/photo-manager/routes.js